import Box from '@mui/material/Box'
import { forwardRef } from 'react'

const BorderedSection = forwardRef(({ children, isLast, ...props }, ref) => (
  <Box
    ref={ref}
    {...props}
    sx={{
      borderColor: '#00000040',
      borderWidth: `1px ${isLast ? 0 : 1}px 1px 0px`,
      borderStyle: 'solid',
      ...(props.sx || {}),
    }}
  >
    {children}
  </Box>
))

export default BorderedSection
